import React, { useState, useEffect, useMemo } from 'react'; // ✅ เพิ่ม useMemo
import { TextField } from '@mui/material';
// import { useState } from 'react'; // (ย้ายไปรวมข้างบน)
import { Button } from '@mui/material';
import { jsPDF } from 'jspdf';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import 'jspdf-autotable';
// import { useEffect } from 'react'; // (ย้ายไปรวมข้างบน)
import NotiAlert from '../../components/NotiAlert/NotiAlert';
import { useSelector } from 'react-redux';
import {
  useLogUsageHistoryQuery,
  useLazyLogUsageHistoryQuery,
} from '../../services/usageHistory';
import { ROLES } from '../../utils/constants';
import { checkAccessRights } from '../../utils/functions/accessRight';
import * as XLSX from 'xlsx';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next'; // ✅ 1. Import hook

// ❌ ย้าย columns array จากตรงนี้ ไปไว้ข้างใน component
// const columns = [ ... ];

const TYPE = 'creditnote';

function CreditNote() {
  const { t } = useTranslation(); // ✅ 2. เรียกใช้ hook

  // ✅ 3. ย้าย columns array มาไว้ข้างใน และใช้ useMemo
  const columns = useMemo(
    () => [
      { id: 'invoice_no', label: t('app.creditNote'), minWidth: 150 }, // ✅ (ใช้ creditNote ตาม TYPE)
      { id: 'customer_name', label: t('navbar.custName'), minWidth: 170 }, // ✅
      { id: 'customer_code', label: t('navbar.custNo'), minWidth: 170 }, // ✅
      { id: 'createdAt', label: t('app.dateTime'), minWidth: 150 }, // ✅
      { id: 'username', label: t('app.username'), minWidth: 150 }, // ✅
    ],
    [t],
  );

  const [total, setTotal] = useState(10);
  const [startDate, setStartDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [order, setOrder] = useState('desc'); // 'asc' หรือ 'desc'
  const [orderBy, setOrderBy] = useState('createdAt'); // คอลัมน์ที่ใช้เรียงลำดับ
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [dataTable, setDataTable] = useState([]);

  const [openAlert, setOpenAlert] = useState(false);
  const [titleAlert, settitleAlert] = useState('');
  const handleOnCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleStartDateChange = (newValue) => {
    setStartDate(newValue ? dayjs(newValue).format('YYYY-MM-DD') : null);
  };

  const handleEndDateChange = (newValue) => {
    setEndDate(newValue ? dayjs(newValue).format('YYYY-MM-DD') : null);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0); // ตั้งค่าหน้าเริ่มต้นเป็นหน้าที่ 0 เมื่อเปลี่ยนแถวต่อหน้า
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    const nextOrder = isAsc ? 'desc' : 'asc';

    setOrder(nextOrder);
    setOrderBy(property);
    setPage(0);
  };
  const [LogUsageHistory] = useLazyLogUsageHistoryQuery();
  async function generatePDF() {
    try {
      const { data: dataPDF } = await getDataForPDF();
      const doc = new jsPDF();

      const tableX = 10;
      const tableY = 20;
      const tableWidth = 190;
      const tableHeight = 50;

      const tableHeaders = columns.filter((column) =>
        // ตรวจสอบว่าข้อมูลสำหรับคอลัมน์นี้ไม่ว่าง
        dataPDF.some((item) => item[column.id] !== undefined),
      );

      doc.setFontSize(16);
      doc.text(t('app.creditNoteHistory'), 10, 10); // ✅

      // สร้างตารางใน PDF โดยใช้ข้อมูลจาก dataPDF
      doc.autoTable({
        head: [tableHeaders.map((header) => header.label)], // สร้างหัวตารางจาก tableHeaders
        body: dataPDF.map((item) =>
          tableHeaders.map((header) => {
            let value; // ประกาศตัวแปร value ไว้นอกช่วงเงื่อนไข

            if (header.id === 'invoice_no') {
              value = item[header.id] ? item[header.id] : '-';
            }

            if (header.id === 'createdAt') {
              value = dayjs(item[header.id]).format('YYYY-MM-DD HH:mm:ss');
            }

            if (header.id === 'username') {
              value = item[header.id] ? item[header.id] : '-';
            }

            // ... สร้างเงื่อนไขสำหรับคอลัมน์อื่น ๆ ที่ต้องการให้แสดงค่า

            return value !== undefined ? value : '-';
          }),
        ),
        startY: tableY,
        margin: { left: tableX },
        tableWidth,
        tableHeight,
      });
      // บันทึกไฟล์ PDF
      doc.save('usage_history.pdf');
    } catch (error) {}
  }

  async function generateExcel() {
    try {
      const { data: dataExcel } = await getDataForPDF(); // ดึงข้อมูลจาก API

      // สร้างหัวตารางจาก columns
      const tableHeaders = columns.filter((column) =>
        dataExcel.some((item) => item[column.id] !== undefined),
      );

      // สร้างข้อมูลหัวตาราง
      const headers = tableHeaders.map((header) => header.label);

      // สร้างข้อมูลเนื้อหา
      const body = dataExcel.map((item) =>
        tableHeaders.map((header) => {
          if (header.id === 'invoice_no') {
            return item[header.id] ? item[header.id] : '-';
          }
          if (header.id === 'createdAt') {
            return dayjs(item[header.id]).format('YYYY-MM-DD HH:mm:ss');
          }
          if (header.id === 'username') {
            return item[header.id] ? item[header.id] : '-';
          }
          // เพิ่มเงื่อนไขสำหรับคอลัมน์อื่น ๆ ที่ต้องการ
          return item[header.id] !== undefined ? item[header.id] : '-';
        }),
      );

      // รวม header และ body
      const excelData = [headers, ...body];

      // สร้างไฟล์ Excel
      const worksheet = XLSX.utils.aoa_to_sheet(excelData); // แปลงข้อมูลเป็น Sheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, t('app.creditNoteHistory')); // ✅

      // บันทึกไฟล์ Excel
      XLSX.writeFile(workbook, 'CreditNote_history.xlsx');
    } catch (error) {
      console.error('Error generating Excel:', error);
    }
  }

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fff', // หรือ theme.palette.action.hover ถ้าต้องการ
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },

  // [ปรับปรุง] ย้าย :hover มาไว้ที่นี่
  '&:hover': {
   
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
    position: 'relative',
    zIndex: 10,
    cursor: 'pointer', // เพิ่ม cursor เพื่อให้รู้ว่า hover ได้
  },

  transition: 'transform 0.15s ',
}));

  const { value: merchant, allMerchant } = useSelector(
    (state) => state.merchant,
  );
  const isAdminRole = checkAccessRights(ROLES.ADMIN_ROLE);
  const sorgcode = isAdminRole ? merchant || '' : allMerchant || '';
  const shouldSkip = isAdminRole && !merchant;
  const { data: LogHistory, isLoading } = useLogUsageHistoryQuery(
    {
      sorgcode,
      page: page === 0 ? 1 : page + 1,
      size: rowsPerPage,
      endDate: endDate,
      startDate: startDate,
      type: TYPE,
      sortBy: orderBy,
      sortOrder: order,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: shouldSkip,
    },
  );

  const getDataForPDF = async () => {
    try {
      if (sorgcode == '-') throw '';
      const { data } = await LogUsageHistory({
        page: 1,
        sorgcode,
        startDate,
        endDate,
        type: TYPE,
        size: total,
        sortBy: orderBy,
        sortOrder: order,
      });
      return data;
    } catch (error) {
      settitleAlert(t('app.pleaseSelectVendor')); // ✅
      setOpenAlert(true);
    }
  };

  useEffect(() => {
    setDataTable(LogHistory?.data);

    if (LogHistory) {
      const { pagination } = LogHistory;

      setTotal(pagination.total);
    }
  }, [LogHistory]);

  return (
    <div>
      <NotiAlert
        open={openAlert}
        setOpen={setOpenAlert}
        title={titleAlert}
        value="error"
        onButtonClick={handleOnCloseAlert}
      />
      <div className="font-bold">{t('app.creditNoteHistory')}</div> {/* ✅ */}
      <div className="flex flex-col xl:flex-row gap-2 mt-2 ">
        <div className="">
          {' '}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={t('app.startDate')} // ✅
              format="DD/MM/YYYY"
              value={startDate ? dayjs(startDate) : null} // ✅ แปลงค่าเป็น dayjs
              onChange={handleStartDateChange}
              renderInput={(params) => (
                <TextField {...params} size="small" sx={{ width: '250px' }} />
              )}
            />
          </LocalizationProvider>
        </div>

        <div className="">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={t('app.endDate')} // ✅
              format="DD/MM/YYYY"
              value={endDate ? dayjs(endDate) : null} // ✅ แปลงค่าเป็น dayjs
              onChange={handleEndDateChange}
              renderInput={(params) => (
                <TextField {...params} size="small" sx={{ width: '250px' }} />
              )}
            />
          </LocalizationProvider>
        </div>
      </div>
      <div className="mt-5">
        <div className="flex flex-col xl:flex-row gap-2">
          <div className="">
            <Button
              variant="contained"
              sx={{ color: 'white' }}
              onClick={() => generatePDF()}
            >
              {t('app.downloadPDF')} {/* ✅ */}
            </Button>{' '}
          </div>{' '}
          <div className="">
            <Button
              variant="contained"
              sx={{ color: 'white' }}
              onClick={() => generateExcel()}
            >
              {t('app.downloadExcel')} {/* ✅ */}
            </Button>
          </div>
        </div>
        <div className="mt-5">
          <div>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell key={column.id}>
                          <TableSortLabel
                            active={orderBy === column.id}
                            direction={orderBy === column.id ? order : 'asc'}
                            onClick={() => handleRequestSort(column.id)}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            {column.label}
                          </TableSortLabel>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {_.size(dataTable) ? (
                    <TableBody>
                      {dataTable.map((item, index) => (
                        <StyledTableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                        >
                          {columns.map((column) => {
                            let value; // ประกาศตัวแปร value ไว้นอกช่วงเงื่อนไข

                            if (column.id === 'time') {
                              value = formatTime(item[column.id]);
                            } else {
                              value = item[column.id];
                            }

                            if (column.id === 'createdAt') {
                              return (
                                <TableCell key={column.id}>
                                  {dayjs(value).format('YYYY-MM-DD HH:mm:ss')}
                                </TableCell>
                              );
                            }
                            if (column.id === 'invoice_no') {
                              return (
                                <TableCell key={column.id}>
                                  {value || '-'}
                                </TableCell>
                              );
                            }

                            if (column.id === 'username') {
                              return (
                                <TableCell key={column.id}>
                                  {value || '-'}
                                </TableCell>
                              );
                            }
                            if (column.id === 'tax_id') {
                              return (
                                <TableCell key={column.id}>
                                  {value || '-'}
                                </TableCell>
                              );
                            }
                            if (column.id === 'status') {
                              return (
                                <TableCell key={column.id}>
                                  {value || '-'}
                                </TableCell>
                              );
                            }
                            if (column.id === 'statusMessage') {
                              return (
                                <TableCell key={column.id}>
                                  {value || '-'}
                                </TableCell>
                              );
                            }
                            if (column.id === 'transferAmount') {
                              return (
                                <TableCell key={column.id}>
                                  {value || '-'}
                                </TableCell>
                              );
                            }

                            if (column.id === 'transferBank') {
                              return (
                                <TableCell key={column.id}>
                                  {value || '-'}
                                </TableCell>
                              );
                            }
                            if (column.id === 'uploadType') {
                              return (
                                <TableCell key={column.id}>
                                  {value || '-'}
                                </TableCell>
                              );
                            }

                            return (
                              <TableCell key={column.id} align={column.align}>
                                {value !== undefined ? value : '-'}
                              </TableCell>
                            );
                          })}
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          <div>{t('app.noDataAvailable')}</div> {/* ✅ */}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={total} // ใช้ค่า 'total' แทน
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </div>
      </div>
      <div className="flex "> </div>
    </div>
  );
}

export default CreditNote;
